export default "__VITE_ASSET__e50d28c0__"